// extracted by mini-css-extract-plugin
export var header = "_s7-1";
export var maskBottom = "_s7-6";
export var maskMiddle = "_s7-7";
export var maskTop = "_s7-5";
export var root = "_s7-0";
export var scrollDownButton = "_s7-3";
export var scrollDownButtonHidden = "_s7-4";
export var viewport = "_s7-2";